import React from "react";
import DataTable from "../../../components/DataTable";
const dataJson = [
  {
    id: "4347348",
    sn: "01",
    userId: "monos4fd5",
    name: "John Doe",
    mobile: "+12558585",
    email: "johndoe@gmail.com",
    position: "Leader",
    status: "active",
    joining: "01/03/2022",
    activation: "planning",
  },
  {
    id: "7dfd8s",
    sn: "01",
    userId: "monos4fdf75",
    name: "John Doe",
    mobile: "+1255fd7fd",
    email: "johndoe@gmail.com",
    position: "Leader",
    status: "active",
    joining: "01/03/2022",
    activation: "planning",
  },
  {
    id: "fs78sf",
    sn: "01",
    userId: "monodfser",
    name: "John Doe",
    mobile: "+12875585",
    email: "johndoe@gmail.com",
    position: "Leader",
    status: "active",
    joining: "01/03/2022",
    activation: "planning",
  },
];

const columns = [
  { id: "sn", label: "S.N", minWidth: 20 },
  { id: "userId", label: "User ID", minWidth: 100 },
  {
    id: "name",
    label: "Name",
    minWidth: 80,
  },
  {
    id: "mobile",
    label: "Mobile",
    minWidth: 80,
  },
  {
    id: "email",
    label: "Email",
    minWidth: 100,
  },
  {
    id: "position",
    label: "Position",
    minWidth: 80,
  },
  {
    id: "status",
    label: "Status",
    minWidth: 80,
  },
  {
    id: "joining",
    label: "Joining",
    minWidth: 80,
  },
  {
    id: "activation",
    label: "Activation",
    minWidth: 80,
  },
];

function createData(
  sn,
  userId,
  name,
  mobile,
  email,
  position,
  status,
  joining,
  activation
) {
  return {
    sn,
    userId,
    name,
    mobile,
    email,
    position,
    status,
    joining,
    activation,
  };
}

const rows = dataJson.map((d) =>
  createData(
    d.sn,
    d.userId,
    d.name,
    d.mobile,
    d.email,
    d.position,
    d.status,
    d.joining,
    d.activation
  )
);

const DirectTable = () => {
  return (
    <DataTable
      columns={columns}
      rows={rows}
      perPageShow={6}
      tableHeight={440}
      className="common_table"
    />
  );
};

export default DirectTable;
